import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType, modalActionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import services from 'services';
import axios from 'axios';
import { GetNopoMicrocategoriesResponse, GetNopoVendorResponse } from 'models/response';

const Delete = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedRowId = useSelector(selectors.configurator.getNOPOSelectedRowId);
  const selectedRow = useSelector(selectors.configurator.getNOPOSelectedRow);
  const rows = useSelector(selectors.configurator.getNOPOLeftTableRows);
  const editedRowId = useSelector(selectors.configurator.getNOPOEditedRowId);

  const optionsValue = useSelector(selectors.configurator.getOptionValueDropdown);
  const optionsDescription = useSelector(selectors.configurator.getOptionDescriptionDropdown);
  const selectedTable = useSelector(selectors.configurator.selectTableToSearch);
  const selectedOptionValue = useSelector(selectors.configurator.getSelectedOptionValue);
  const deleteRow = async () => {
    try {
      if (selectedRow?.idAction === undefined) throw new Error('No row selected');
      await services.deleteExpActionTable(selectedRow?.idAction);
      utils.app.notify('success', t('deleteActionTableSuccess'));
      dispatch(
        actions.configurator.setNoPoLeftTableRows(
          (rows as any[]).filter((row) => row.idAction !== selectedRow.idAction),
        ),
      );
      if (selectedTable === 'microcategory') {
        dispatch(
          actions.configurator.setOptionValueDropdown(
            optionsValue.filter(
              (option) => option.value !== (selectedRow as GetNopoMicrocategoriesResponse)?.microcategoryCode,
            ),
          ),
        );
        dispatch(
          actions.configurator.setOptionDescriptionDropdown(
            optionsDescription.filter(
              (option) => option.value !== (selectedRow as GetNopoMicrocategoriesResponse)?.microcategoryCode,
            ),
          ),
        );
        dispatch(
          actions.configurator.setSelectedOptionValue(
            selectedOptionValue.filter(
              (option) => option.value !== (selectedRow as GetNopoMicrocategoriesResponse)?.microcategoryCode,
            ),
          ),
        );
      }
      if (selectedTable === 'vendor') {
        const { data: subjects } = await services.getAllSubject(selectedRow.idCompany);
        const chosenSubject = subjects.find(
          (subject) => subject.supplierCode === (selectedRow as GetNopoVendorResponse).supplierCode,
        );
        if (chosenSubject === undefined) throw new Error('No subject found');
        dispatch(
          actions.configurator.setOptionValueDropdown(
            optionsValue.filter((option) => option.value !== chosenSubject.idWSubject),
          ),
        );
        dispatch(
          actions.configurator.setOptionDescriptionDropdown(
            optionsDescription.filter((option) => option.value !== chosenSubject.idWSubject),
          ),
        );
        dispatch(
          actions.configurator.setSelectedOptionValue(
            selectedOptionValue.filter((option) => option.value !== chosenSubject.idWSubject),
          ),
        );
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error('error.response:', error.response);
        utils.app.notify('fail', `${t('error')} ${error.response}`);
        return;
      }
      console.error(error);
    } finally {
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <CommonButton
      id="delete-row-action-table"
      action={() =>
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.DELETE_CONFIRMATION,
            props: {
              subtitle: t('delete-rows-table'),
              func: async () => await deleteRow(),
            },
          }),
        )
      }
      scope="tertiary"
      value={t('nopoDeleteActionTable')}
      customIcon="trash"
      disabled={
        selectedRowId === undefined ||
        selectedRowId === '' ||
        editedRowId !== undefined ||
        !utils.user.isActionByCompanyActive(actionType.ACTION_TABLE_DELETE_ROW, selectedRow?.companyName)
      }
    />
  );
};

export default Delete;
